// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MMqGgFeVd9sCYVIchv2I{margin-bottom:6px}.yf2kvh_3DQ5AEuDC0fyA{background:var(--background-primary-transparent);border-radius:6px;justify-content:space-between;align-items:center;height:32px;margin-bottom:2px;padding-right:8px;display:flex}.doXeKdVOO38SO7P85qSI{color:var(--content-primary-tertiary);padding:4px 8px}.doXeKdVOO38SO7P85qSI._4iN7j97tSAvyykXlP4z{color:var(--content-brand-primary)}.hMdEi7xz4Tz5kRzTG5j4{align-items:center;display:flex}.SlLPeHnRL_4lUkuV81gx{padding-left:24px;position:relative}.SlLPeHnRL_4lUkuV81gx:after{background-color:var(--gray-30);content:"";width:1px;position:absolute;top:0;bottom:0;left:16px}.l58OB76berMojjWDbb4G span{margin:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `MMqGgFeVd9sCYVIchv2I`,
	"label": `yf2kvh_3DQ5AEuDC0fyA`,
	"label__icon": `doXeKdVOO38SO7P85qSI`,
	"labelIcon": `doXeKdVOO38SO7P85qSI`,
	"activeIcon": `_4iN7j97tSAvyykXlP4z`,
	"label__box": `hMdEi7xz4Tz5kRzTG5j4`,
	"labelBox": `hMdEi7xz4Tz5kRzTG5j4`,
	"section": `SlLPeHnRL_4lUkuV81gx`,
	"section__item": `l58OB76berMojjWDbb4G`,
	"sectionItem": `l58OB76berMojjWDbb4G`
};
export default ___CSS_LOADER_EXPORT___;
